module.exports = __webpack_public_path__ + "img/pamphlet--01.77194fd6.png";